<template>
  <div class="profil-container">
    <need-review :title="'Need Review'" :modalClose="closeReview" :submit="needReview" v-if="is_catatan_open" />
    <need-review :title="'Reject'" :modalClose="closeReject" :submit="reject" v-if="is_reject_open" />
    <h3 class="profil-title">
      Terima Kasih
    </h3>
    <!-- <div
      class="instruction-wrapper"
      v-if="!$store.state.kplhStore.is_vendor_done"
    >
      <div class="instruction-list">
        <div class="instruction-number">1.</div>
        <div class="instruction-text">
          Formulir Pra-Kualifikasi K3L ini telah diisi oleh Perusahaan yang
          mengajukan dengan sebenar-benarnya.
        </div>
      </div>
      <div class="instruction-list">
        <div class="instruction-number">2.</div>
        <div class="instruction-text">
          Semua data yang diisikan dan/atau lampiran dokumen pendukung adalah
          benar dan akurat pada saat dokumen formulir Pra-Kualifikasi K3L ini
          diserahkan ke pihak PT Berau Coal.
        </div>
      </div>
      <div class="instruction-list">
        <div class="instruction-number">3.</div>
        <div class="instruction-text">
          Jika data yang diisikan dan/atau lampiran dokumen pendukung yang
          diberikan tidak benar, tidak akurat dan tidak diketahui oleh Pimpinan
          Tertinggi Perusahaan maka tidak akan diperiksa dan Perusahaan tidak
          akan diundang untuk mengikuti proses selanjutnya.
        </div>
      </div>
      <div class="vendor-form mt40">
        <div
          class="input-100"
          style="display:flex; align-items:center; justify-content:center"
        >
          <input
            type="checkbox"
            value="1"
            v-model="selesai"
            v-if="!$store.state.kplhStore.is_vendor_done"
          />
          <input type="checkbox" value="1" v-model="done" v-else disabled />
          <label class="ml20"
            >Dengan ini menyatakan bahwa pernyataan yang telah diisi dan dokumen
            pendukung yang dilampirkan sudah benar, akurat dan lengkap serta
            menyetujui seluruh peraturan yang tertera diatas</label
          >
        </div>
      </div>
    </div> -->
    <div class="instruction-wrapper">
      <p class="profil-subtitle">
        Silahkan tekan tombol selesai untuk di proses ke tahap selanjutnya
      </p>
    </div>

    <div class="profil-btn-wrapper">
      <div @click="goProcess()" class="btn-landing" v-if="!is_vendor_done">
        Selesai
      </div>
      <div @click="sipmApprove()" class="btn-landing" v-if="is_sipm_validation && sipm_preview">
        Approve
      </div>
      <div @click="openReview()" class="btn-landing" v-if="is_sipm_validation && sipm_preview">
        Need Review
      </div>
      <div @click="openReject()" class="btn-landing" v-if="is_sipm_validation && sipm_preview">
        Reject
      </div>
      <div @click="goBack()" class="btn-landing">Kembali</div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { api, api_lp } from '../../services/config'
export default {
  components: {
    NeedReview: () => import('@/components/customModal/need-review.vue'),
  },
  data() {
    return {
      selesai: 0,
      done: 1,
      is_catatan_open: false,
      is_reject_open: false,
      catatan: '',
    }
  },
  computed: {
    is_vendor_done() {
      return this.$store.state.kplhStore.is_vendor_done
    },
    is_sipm_validation() {
      return this.$store.state.kplhStore.is_sipm_validation
    },
    is_sipm_approved() {
      return this.$store.state.kplhStore.is_sipm_approved
    },
    sipm_preview() {
      return this.$store.state.kplhStore.sipm_preview
    },
  },
  methods: {
    goBack() {
      this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'grupjm' })
    },
    goProcess() {
      this.$store.commit('kplhStore/PROCESSING_KPLH', {
        tingkat_resiko: this.$tingkatResikoValue(),
      })
    },
    async getHseUser() {
      const kode = this.$store.state.kplhStore.choosed_company
      this.$store.commit('kplhStore/SET_KPLH_FORM', {
        name: 'globalLoading',
        value: true,
      })
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${api_lp}/api/v1/vendor/user-hse/${kode}`,
        })

        if (data && data.status == 'success') {
          const hseCompanyUser = await data.data.reduce((res, item) => {
            if (item.company_detail.role_id == 6) res.push(item.company_detail)

            return res
          }, [])

          const headHseCompanyUser = await data.data.reduce((res, item) => {
            if (item.company_detail.role_id == 7) res.push(item.company_detail)

            return res
          }, [])

          this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'globalLoading',
            value: false,
          })
          return (
            (await hseCompanyUser.length) > 0 && headHseCompanyUser.length > 0
          )
        }
      } catch (error) {
        this.$store.commit('kplhStore/SET_KPLH_FORM', {
          name: 'globalLoading',
          value: false,
        })
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message')
        )
      }
    },
    async sipmApprove() {
      try {
        const getHse = await this.getHseUser()
        if (getHse) {
          this.$store.commit('kplhStore/SIPM_APPROVE_KPLH', {
            tingkat_resiko: this.$tingkatResikoValue(),
          })
        } else {
          this.$store.commit(
            'SET_NOTIF',
            'Tidak ditemukan HSE dan atau Head HSE pada Company GEMS yang dipilih, Silahkan Atur ulang Company GEMS'
          )
        }
      } catch (error) {
      }
    },
    openReview() {
      this.is_catatan_open = true
    },
    closeReview() {
      this.is_catatan_open = false
    },
    async needReview(catatan) {
      const id = this.$route.params.id
      const user_id = this.$route.params.user
      const url = `${api}/api/v1/request/reviewsipm-kplh/${id}`

      this.$store.commit('kplhStore/SET_KPLH_FORM', {
        name: 'globalLoading',
        value: true,
      })
      try {
        const { data: response } = await axios({
          method: 'POST',
          url,
          data: {
            user_id,
            note: catatan,
          },
        })

        if (response && response.status == 'success') {
          this.is_catatan_open = false
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'is_sipm_validation',
            value: false,
          })
          await this.$store.commit('SET_NOTIF', response.message)
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'globalLoading',
            value: false,
          })
        }
      } catch (error) {
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
        this.$store.commit('kplhStore/SET_KPLH_FORM', {
          name: 'globalLoading',
          value: false,
        })
      }
    },
    openReject() {
      this.is_reject_open = true
    },
    closeReject() {
      this.is_reject_open = false
    },
    async reject(catatan) {
      try {
        await this.$store.commit('kplhStore/SET_KPLH_FORM', {
          name: 'globalLoading',
          value: true,
        })
        const url = `${api}/api/v1/request/reject-kplh/${this.$route.params.id}`
        const { data } = await axios({
          method: 'POST',
          url,
          data: {
            note: catatan,
            user_id: this.$route.params.user,
          },
        })
        if (data) {
          this.is_reject_open = false
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'is_sipm_validation',
            value: false,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'globalLoading',
            value: false,
          })
          this.$store.commit('SET_NOTIF', data.message)
        }
      } catch (error) {
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
        await this.$store.commit('kplhStore/SET_KPLH_FORM', {
          name: 'globalLoading',
          value: false,
        })
      }
    },
  },
}
</script>
